/**
 * AiHighlight - TipTap extension for highlighting AI-generated content
 * that requires review.
 *
 * Usage:
 * - Apply to uncertain AI-generated content
 * - Lawyer must review and clear all highlights before sending
 * - Yellow background with tooltip showing reason
 */
import { Mark } from '@tiptap/core'

export const AiHighlight = Mark.create({
  name: 'aiHighlight',

  addOptions() {
    return {
      HTMLAttributes: {},
    }
  },

  addAttributes() {
    return {
      reason: {
        default: null,
        parseHTML: element => element.getAttribute('data-reason'),
        renderHTML: attributes => {
          if (!attributes.reason) {
            return {}
          }
          return {
            'data-reason': attributes.reason,
          }
        },
      },
    }
  },

  parseHTML() {
    return [
      {
        tag: 'span[data-ai-highlight]',
      },
    ]
  },

  renderHTML({ HTMLAttributes }) {
    return [
      'span',
      {
        ...this.options.HTMLAttributes,
        ...HTMLAttributes,
        'data-ai-highlight': '',
        class: 'ai-highlight',
      },
      0,
    ]
  },

  addCommands() {
    return {
      setAiHighlight:
        (attributes) =>
        ({ commands }) => {
          return commands.setMark(this.name, attributes)
        },
      toggleAiHighlight:
        (attributes) =>
        ({ commands }) => {
          return commands.toggleMark(this.name, attributes)
        },
      unsetAiHighlight:
        () =>
        ({ commands }) => {
          return commands.unsetMark(this.name)
        },
    }
  },
})

export default AiHighlight
